<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
/* .layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
} */
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}

.avatar {
  margin-top: 30px;
  height: 60px;
  width: 60px;
  border-radius: 30px;
}

.avatar-nav {
  margin-top: 15px;
  height: 34px;
  width: 34px;
  border-radius: 20px;
}

.avatar-block {
  text-align: center;
  height: 150px;
  background: #191a22;
  /* background-image:url(../../assets/header-profile-skin-2.png); */
}
</style>
<template>
  <div class="layout">
    <Layout>
      <Sider
        ref="side1"
        hide-trigger
        collapsible
        :collapsed-width="78"
        v-model="isCollapsed"
        :style="{background:'#191A22'}"
      >
        <!-- <div>
          <h2 style="color:white">新点移动研发过程管理</h2>
        </div>-->

        <div class="avatar-block" v-show="!isCollapsed">
          <img class="avatar" :src="user.avatar" />
          <div>
            <div style="color:white">{{user.displayName}}</div>
          </div>
        </div>
        <Menu
          :style="{background:'#191A22'}"
          :active-name="menu.activeName"
          theme="dark"
          width="auto"
          :class="menuitemClasses"
          ref="side_menu"
          @on-select="menuSelect"
        >
          <MenuGroup v-for="menu in menuData" :key="menu.id" :title="menu.name">
            <MenuItem v-for="submenu in menu.submenu" :key="submenu.id" :name="submenu.path">
              <Icon :type="submenu.icon"></Icon>
              <span>{{submenu.name}}</span>
            </MenuItem>
          </MenuGroup>
        </Menu>
      </Sider>
      <Layout :style="{height: '100vh',overflow:'hidden'}">
        <Header :style="{padding: 0}" class="layout-header-bar">
          <Icon
            @click.native="collapsedSider"
            :class="rotateIcon"
            :style="{margin: '20px 20px'}"
            style="float:left;"
            type="md-menu"
            size="24"
          ></Icon>
          <Breadcrumb style="float:left">
            <BreadcrumbItem>{{currentTopTitle}}</BreadcrumbItem>
            <BreadcrumbItem :to="currentSubPath">{{currentSubTitle}}</BreadcrumbItem>
          </Breadcrumb>
          <!-- <div style="float:right;margin-right:30px;overflow:hidden">
            <img :src="user.avatar" class="avatar-nav"/>
          </div>-->
          <div style="float:right;margin-right:20px;overflow:hidden">
            <Button type="text" style="font-size:15px;" icon="md-create" @click="feedback">意见反馈</Button>
            <Button type="text" style="font-size:15px;" icon="md-power" @click="logout">退出账户</Button>
          </div>
        </Header>
        <div :style="{padding:'15px',overflowY:'auto'}">
          <!-- <Content :style="{background: '#fff',padding:'15px'}"> -->
          <router-view></router-view>
          <!-- </Content> -->
        </div>
      </Layout>
    </Layout>

    <Modal title="意见反馈" v-model="feedbackModal.modal" @on-visible-change="onFeedbackModalVisible">
      <Input
        type="textarea"
        :rows="4"
        placeholder="请输入您的意见或问题..."
        v-model="feedbackModal.form.content"
      />
      <div slot="footer">
        <Button type="text" size="large" @click="feedbackCancel">取消</Button>
        <Button type="primary" size="large" @click="submitFeedback">确定</Button>
      </div>
    </Modal>
    <Modal title="更新提示" v-model="updateModal.modal">
      <pre style="font-size:14px;color:black">{{updateModal.model.updateinfo}}</pre>
      <div slot="footer">
        <Button type="primary" size="large" @click="updateModal.modal=false">知道了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCollapsed: false,
      currentTopTitle: "",
      currentSubTitle: "",
      currentSubPath: "",
      user: {
        displayName: "",
        rolename: "",
        avatar: "http://218.4.136.126:1443/oa9_v7/" + localStorage.photourl,
      },
      menu: {
        activeName: "",
        openMenuNames: [],
      },
      menuData: [],
      feedbackModal: {
        modal: false,
        form: {
          content: "",
        },
      },
      updateModal: {
        modal: false,
        model: {},
      },
    };
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    dropclick(name) {
      if (name === 1) {
        this.logout();
      }
    },
    //用户注销登出
    logout() {
      let _this = this;
      this.$Modal.confirm({
        title: "提示",
        content: "您要退出系统吗？",
        onOk: () => {
          localStorage.removeItem("token");
          localStorage.removeItem("photourl");
          _this.$router.replace("/login");
        },
      });
    },
    menuSelect(name) {
      this.updateCurrentTitle(name);
      this.$router.replace(name);
    },
    loadMenu() {
      let _this = this;
      this.$http.get({
        method: "base/menu/getUserMenuList",
        params: {},
        success: function (data) {
          _this.menuData = data;
          _this.updateMenu();
        },
        failure(code, msg) {},
      });
    },
    updateCurrentTitle(path) {
      for (let i = 0; i < this.menuData.length; i++) {
        for (let j = 0; j < this.menuData[i].submenu.length; j++) {
          if (this.menuData[i].submenu[j].path === path) {
            this.currentTopTitle = this.menuData[i].name;
            this.currentSubTitle = this.menuData[i].submenu[j].name;
            this.currentSubPath = this.menuData[i].submenu[j].path;
            break;
          }
        }
      }
    },
    //获取用户信息
    getUserInfo() {
      let _this = this;
      this.$http.get({
        method: "base/user/userinfo",
        params: {},
        success: function (data) {
          _this.user.displayName = data.displayname;
          _this.setCurrentUserInfo(data)
          // _this.user.rolename = data[2];
        },
        failure(code, msg) {},
      });
    },
    updateMenu() {
      this.menu.activeName = this.$route.path;
      this.updateCurrentTitle(this.$route.path);
      //根据路由路径，设置默认选择子菜单和默认展开菜单，比较灵活
      this.$nextTick(() => {
        this.$refs.side_menu.updateOpened();
        this.$refs.side_menu.updateActiveName();
      });
    },
    //意见反馈
    feedback() {
      this.feedbackModal.modal = true;
    },
    //取消意见反馈框
    feedbackCancel() {
      this.feedbackModal.modal = false;
    },
    //提交意见反馈
    submitFeedback() {
      let _this = this;
      this.$http.post({
        method: "base/feedback/add",
        params: this.feedbackModal.form,
        success: function (data) {
          _this.feedbackModal.modal = false;
          _this.$Message.success({
            content: "感谢您的反馈！",
          });
        },
        failure(code, msg) {
          _this.$Message.warning({
            content: msg,
          });
        },
      });
    },
    onFeedbackModalVisible() {
      this.feedbackModal.form = {};
    },
    //检查更新提示
    checkUpdate() {
      let _this = this;
      this.$http.get({
        method: "base/sysupdate/checkupdate",
        success: function (data) {
          if (data.hasupdate) {
            _this.updateModal.modal = true;
            _this.updateModal.model = data.update;
          }
        },
      });
    },
  },
  mounted() {
    this.loadMenu();
    this.getUserInfo();
    this.checkUpdate();
    document.title = "新点移动研发过程管理";
  },
};
</script>
